module.exports = __webpack_public_path__ + "img/coin-pile-drawing.4a0bed5c.png";